import {TargetGroup} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/target_group.types';
import {GetDrawerNavigationBulkResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/navigation/v1/service.types';
import {COLORS, FONT_SIZES, FONT_WEIGHTS, Tabs} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';

import {
  convertTargetGroupToGender,
  useSelectedTargetGroup,
} from '../../shared-deprecated/useSelectedTargetGroup';
import {useNavigationCategory} from './useNavigationCategory';

export const TargetGroupSwitchView: React.FC<
  GetDrawerNavigationBulkResponse['targetGroups']
> = ({targetGroups}) => {
  const {targetGroup, switchTargetGroup} = useSelectedTargetGroup();
  const {setCurrentCategoryId} = useNavigationCategory();

  const tabs = targetGroups.map(targetGroup => ({
    'data-testid': `genderButton_${targetGroup.label}`,
    label: targetGroup.label,
    value: targetGroup.targetGroup,
  }));

  const onTabClick = (targetGroup: string | number) => {
    switchTargetGroup(targetGroup as TargetGroup);
    setCurrentCategoryId();
  };

  return (
    <Wrapper>
      <TabGroup
        buttonComponent={TabButton}
        onTabClick={onTabClick}
        dataTestId={`genderSelected_${convertTargetGroupToGender(targetGroup)}`}
        selectedTabValue={targetGroup}
        tabs={tabs}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  border-bottom: 1px solid ${COLORS.Grey3};
  padding: 0 20px;
  margin: 0 -20px;
`;

const TabGroup = styled(Tabs)`
  height: auto;
`;

const TabButton = styled.button<{
  active?: boolean;
}>`
  color: ${({active}) => (active ? COLORS.Black : COLORS.Grey2)};
  flex-grow: 0;
  font-weight: ${FONT_WEIGHTS.mediumHeavy};
  font-size: ${FONT_SIZES.px16};
  margin-right: 20px;
  padding: 1rem 0;
  z-index: 1;
`;
